import { Entity } from '@api/api/entity-schema';
import {
  ChartAssetData,
  ChartTypeSelector,
  ChartTypeSelectorProps,
  HorizonWithPriceRange,
  hasOHLC,
  SeriesType,
} from '@chart';
import { ChartNavigateConfigParams } from '@terminal/hooks/use-chart-navigate/useChartNavigate';
import { ReactNode } from 'react';

import { ChartMessageHeader } from '../chart-message-header/ChartMessageHeader';
import { ChartPrice } from '../chart-price/ChartPrice';
import styles from './ChartHeader.module.scss';

interface ChartHeaderProps {
  chartData: ChartAssetData[];
  horizonWithPriceRanges: HorizonWithPriceRange[];
  chartConfig: ChartNavigateConfigParams;
  entity: Entity | undefined;
  changeSeriesType: ChartTypeSelectorProps['onChange'];
  seriesType: SeriesType;
  renderFullScreenButton: () => ReactNode;
  isLegacyVariant?: boolean;
  isChatMessage?: boolean;
  showChartTypeSelector?: boolean;
}

export const ChartHeader = ({
  chartData,
  chartConfig,
  horizonWithPriceRanges,
  entity,
  changeSeriesType,
  seriesType,
  renderFullScreenButton,
  isLegacyVariant = true,
  isChatMessage,
  showChartTypeSelector = true,
}: ChartHeaderProps) => {
  if (!isLegacyVariant) {
    return null;
  }

  if (isChatMessage) {
    return (
      <ChartMessageHeader
        chartData={chartData}
        showChartArea={!!horizonWithPriceRanges.length}
        chartConfig={chartConfig}
      />
    );
  }

  return (
    <div className={styles.headerContainer}>
      {chartData[0] && entity && (
        <ChartPrice
          className={styles.chartPriceStyled}
          entity={entity}
          snakeMeta={chartData[0].snakeMeta}
          ts={chartData[0].ts}
        />
      )}
      {showChartTypeSelector && (
        <ChartTypeSelector
          className={styles.chartTypeSelectorStyled}
          selectedSeriesType={seriesType}
          onChange={changeSeriesType}
          disableMenuBar={!chartData.length}
          hasOHLC={hasOHLC(chartData[0])}
        />
      )}
      {renderFullScreenButton()}
    </div>
  );
};
